import iconRed from "../../assets/logos/icon-red.png";
import iconWhite from "../../assets/logos/icon-white.png";
import iconBlack from "../../assets/logos/icon-black.png";

// Icon-only render of the official ProximityParks brand mark.
// Sources are the actual brand PNGs (cropped from the full logo) so the icon
// stays pixel-identical to anything Marketing produces. `variant` swaps the
// color treatment; default is the red gradient. `white`/`black` props are
// kept as backwards-compatible shortcuts for legacy callers.
export default function PPIcon({ size = 32, variant = "red", white = false, black = false }) {
  const v = white ? "white" : black ? "black" : variant;
  const src = v === "white" ? iconWhite : v === "black" ? iconBlack : iconRed;
  // The cropped icon's natural aspect is ~0.81 (width / height).
  const aspect = 0.81;
  return (
    <img
      src={src}
      alt="ProximityParks"
      width={size * aspect}
      height={size}
      style={{ display: "block", flexShrink: 0 }}
      draggable={false}
    />
  );
}
